import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { NaturalLanguageComponent } from './naturallanguage.component';
import { NaturalLanguageStore } from './naturallanguage.store';

@inject('httpStore')
@observer
export class NaturalLanguageProvider extends Component {
    natLangInitialized = false;

    constructor(props) {
        super(props);

        const { httpStore } = props;

        this.store = new NaturalLanguageStore({
            httpStore: httpStore
        });

        this.store.initializeNatLang(httpStore, httpStore.rootURL);

        this.natLangInitialized = true;
    }

    render() {
        return <Provider store={this.store}>
            <NaturalLanguageComponent key='natlang' />
        </Provider>;
    }
}
